import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Toolbar } from '@kerfjs/ui/toolbar';
import type { SafeHtml } from 'kerfjs';
import { Pencil } from 'lucide';

import { PrimaryAddControl } from '../demand-editor/components/primary-add-control.js';

/**
 * Secondary header for Vendors (HS2-BBZXKM): "New Vendor…" on the vendor list, and
 * "Edit Vendor…" on one vendor's page. Both open the vendor dialog.
 */
export function VendorsHeader({ vendorId }: { vendorId: string | null }): SafeHtml {
  return (
    <Toolbar
      label="Vendor Actions"
      trailing={
        vendorId === null ? (
          <PrimaryAddControl action="vendor-new" label="New Vendor…" />
        ) : (
          <Button
            tone="neutral"
            emphasis="primary"
            size="default"
            shape="pill"
            action="vendor-edit"
            icon={<LucideIcon icon={Pencil} name="" />}
            rootAttributes={{ 'data-vendor-id': vendorId }}
          >
            Edit Vendor…
          </Button>
        )
      }
    />
  );
}
